import { Fragment, Slice } from 'hubspot-prosemirror/pm/model';
import { useCallback, useContext, useMemo } from 'react';
import { createInsertVideoButton } from '../../draft-transplant/createInsertVideoButton';
import GoVideoDialog from '../../draft-transplant/GoVideoDialog';
import { EditorConfigContext } from '../contexts/EditorConfigContext';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { makeLinkNode, makeInlineVidyardVideoNode } from '../plugins/link/LinkUtils';
import { convertToPlaintextState } from '../utils/plaintextUtils';
import { getGlobalVars } from '../utils/globalVarUtil';

/** Configuration for the Video Insertion capability (HubSpot video hosting) */
import { jsx as _jsx } from "react/jsx-runtime";
const TICKET_OBJECT_TYPE = 'TICKET';
export default function InsertVideo(props) {
  const {
    objectType,
    recipientEmail,
    insertWithThumbnail,
    insertWithEmbed,
    Button,
    onInsertComplete,
    closeModal,
    useInsertMenuVersion,
    modalType
  } = props;
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const {
    usePlaintextMode,
    plaintextOptions
  } = getGlobalVars(useContext(EditorConfigContext));
  const VideoButton = useMemo(() => createInsertVideoButton({
    CustomButtonComponent: Button
  }), [Button]);
  const handleVideoInsertion = useCallback(videoData => {
    const {
      url: videoUrl,
      thumbnailSrc: videoThumbnailUrl,
      videoTitle,
      uuid,
      base_url
    } = videoData;
    const {
      schema
    } = editorState;
    let tr = editorState.tr;
    const isVidyardVideo = !!(uuid && base_url);
    if (insertWithEmbed && isVidyardVideo) {
      const inlineVidyardVideoNode = makeInlineVidyardVideoNode(schema, {
        url: videoUrl,
        videoTitle,
        base_url
      });
      tr = tr.replaceSelection(new Slice(Fragment.fromArray([inlineVidyardVideoNode, schema.nodes.paragraph.create()]), 0, 0));
    } else if (insertWithThumbnail) {
      const imageNode = schema.nodes.image.create({
        src: videoThumbnailUrl,
        isTemporary: false,
        uploadPercent: 0,
        width: '260px'
      });
      const linkNode = makeLinkNode(schema, videoUrl, videoTitle, true, false);
      tr = tr.replaceSelection(new Slice(Fragment.fromArray([schema.nodes.paragraph.create(), imageNode, linkNode, schema.nodes.paragraph.create()]), 0, 0));
    } else {
      const linkNode = makeLinkNode(schema, videoUrl, videoTitle, true, false);
      tr = tr.replaceSelection(new Slice(Fragment.from(linkNode), 0, 0));
    }
    setEditorState(usePlaintextMode ? convertToPlaintextState(editorState.apply(tr), plaintextOptions) : editorState.apply(tr));
    onInsertComplete === null || onInsertComplete === void 0 || onInsertComplete();
  }, [insertWithEmbed, insertWithThumbnail, editorState, setEditorState, onInsertComplete, usePlaintextMode, plaintextOptions]);
  if (useInsertMenuVersion) {
    return /*#__PURE__*/_jsx(GoVideoDialog, {
      isInServiceHub: objectType === TICKET_OBJECT_TYPE,
      onClose: e => closeModal === null || closeModal === void 0 ? void 0 : closeModal(e),
      onChange: handleVideoInsertion,
      recipientEmail: recipientEmail,
      modalType: modalType
    });
  }
  return /*#__PURE__*/_jsx(VideoButton
  // @ts-expect-error ts-migrate error
  , {
    onChange: handleVideoInsertion,
    objectType: objectType,
    recipientEmail: recipientEmail,
    useProsemirror: true
  });
}